module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAUVBMVEUAAACMmK+MmLCNmLCLmK+RoriMmLCLmLCMmbCNmbGOmLCMl7CQm7SMl7CNmLGNmLGMmLGMmbGMl6+PmbGMmrKMmK+Ml7CMl6+LmLCMl7CLl6+x68wVAAAAGnRSTlMAZu+IxgqpznhGINMj951zW0pBPDXmxb2Lh3CncakAAADDSURBVEjH7ZQ3DsMwEASpwKgcnO7/DzVUCMLRhPZou9TUO8UcQKqvWYtT1njfE6Dn+4kgExMqLFRMcFhwTAgd2ndBMWZ7vrez+jdTm7d3VGYZnogaLd+35RZqxHvdsNNjzH5MLw3ekYX7fX6Ew+ADIwlmOBwc4XEwpwyiYGF4YME4XFtKMsBgYfjARjh8PnuhGgdzDAjG4fivXOIL1Rs28T/d6o37qJIssDfmI/2pMoXqEi4hLbyA8IiFEQh6LBhe/cgbpwZTvS2mHRoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/homeSVG/icon_top.png
// module id = T6kp
// module chunks = 2